<template>
    <div class="listing-hours-edit" id="edit-hours">
        <hours-settings :hours-type="model.type" :holiday-condition="listingHolidayCondition" @update-model="updateModel"></hours-settings>
        <div class="td-text-right mt-2">
            <button :class="['td-btn', 'secondary', { 'disabled': isLoading }]" @click="saveHours($event)">Save Hours Settings</button>
        </div>
       
        <div class="td-card rounded shadow mt-3">
            <div v-if="model.type == HoursOfOperationType.AlwaysOpen" class="td-banner success my-2">
                <icon name="faClock" type="solid"></icon>
                <div class="td-flex"><p>Your location is open 24/7.</p></div>
            </div>
            <hours-table-navigation @update-navigation="updateNavigation" :hours-type="model.type" :add-exception="showAddException" :table-tab="tab" :timezone="listingTimezone"></hours-table-navigation>
            <weekly-schedule v-if="tab == HoursTab.Hours" :hours-type="afterHoursType" :entries="allEntries" @update-entries="updateEntries"></weekly-schedule>
            <hours-exceptions v-if="tab == HoursTab.Exceptions" :exceptions="allExceptions"
                              :add-exception="showAddException" @cancel-update="cancelUpdate" @update-exceptions="updateExceptions"></hours-exceptions>
            <holiday-hours v-if="tab == HoursTab.HolidayHours" :holidays="listingHolidays" @update-holidays="updateHolidays" :country-code="listing.location.countryCode" :condition="model.majorHolidaysCondition"></holiday-hours>
            <div class="td-flex align-end">
                <button v-if="tab == HoursTab.Hours" title="Clear all" class="td-btn danger icon-left hide-mobile mt-4" @click.prevent="clearHours"><icon name="faXmark" type="solid"></icon> Clear All</button>
                <button v-if="tab == HoursTab.Hours" title="Clear all" class="td-btn danger icon-only show-mobile mt-4" @click.prevent="clearHours"><icon name="faXmark" type="solid"></icon></button>
                <div v-if="tab != HoursTab.Hours"></div>
                <div class="td-text-right">
                    <button v-if="tab == HoursTab.Hours" :class="['td-btn', 'mt-4', 'secondary', { 'disabled': isLoading }]" @click="saveHours($event)">Save Hours</button>
                    <!--<button v-if="tab == HoursTab.Exceptions" :class="['td-btn', 'mt-4', 'secondary', { 'disabled': isLoading }]" @click="saveExceptions($event)">Save Exceptions</button>-->
                    <button v-if="tab == HoursTab.HolidayHours" :class="['td-btn', 'mt-4', 'secondary', { 'disabled': isLoading }]" @click="saveHolidayHours($event)">Save Holiday Hours</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import script from './EditHours';
    export default script;</script>

<style lang="less">
    @import "./EditHours.less";
</style>